import {
  File,
  FileImage,
  FileSpreadsheet,
  FileText,
  type LucideIcon,
} from 'lucide-react'
import {
  PRODUCT_SOURCE_CSV_MIME,
  PRODUCT_SOURCE_XLSM_MIME,
  PRODUCT_SOURCE_XLS_MIME,
  PRODUCT_SOURCE_XLSX_MIME,
} from './productSourceFileTypes'

export function getProductSourceIcon(sourceType: string): LucideIcon {
  if (sourceType === 'application/pdf') {
    return FileText
  }
  if (
    sourceType === 'image/jpeg' ||
    sourceType === 'image/png' ||
    sourceType === 'image/bmp' ||
    sourceType === 'image/x-ms-bmp'
  ) {
    return FileImage
  }
  if (
    sourceType === PRODUCT_SOURCE_XLSX_MIME ||
    sourceType === PRODUCT_SOURCE_XLSM_MIME ||
    sourceType === PRODUCT_SOURCE_XLS_MIME ||
    sourceType === PRODUCT_SOURCE_CSV_MIME ||
    sourceType === 'application/csv'
  ) {
    return FileSpreadsheet
  }
  return File
}
